import Crypto from 'crypto-js';
import axios from 'axios';

/**
 * @param {String} token
 */
function setAuthHeader(token) {
  axios.defaults.headers.common.Authorization = `Bearer ${token}`;
}

function unsetAuthHeader() {
  delete axios.defaults.headers.common.Authorization;
}

export default (store) => {
  store.subscribe((mutation) => {
    if (mutation.type === 'LOGIN') {
      const payload = JSON.stringify(mutation.payload);
      const encrypt = Crypto.AES.encrypt(payload, process.env.VUE_APP_SECRET);
      setAuthHeader(mutation.payload.token);
      window.localStorage.setItem('wp-user', btoa(encrypt.toString()));
    }

    if (mutation.type === 'LOGOUT') {
      unsetAuthHeader();
      window.localStorage.removeItem('wp-user');
    }
  });
};
